export default "__VITE_ASSET__CrFFOj11__"